module.exports = __webpack_public_path__ + "media/images/sp/items/board/board_01-7f24298d34cf4c8fd73e450827e8e372.jpg";